import { RootStore } from 'store/rootStore';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { formUtils } from '@insurancemenu/imenu-components-lib';
import { FormObjectFromJSON } from '@insurancemenu/imenu-components-lib/dist/types';
import { requestFormById } from 'api/operations/formService';

export const INITIAL_FORM_OBJECT: Readonly<FormObjectFromJSON> = Object.freeze({
  id: '',
  formTitle: '',
  sections: [],
  description: '',
  productLineIds: [],
});

export default class EditPrimaryModalStore {
  rootStore: RootStore;
  loading = false;
  form: FormObjectFromJSON;
  isEditPrimaryModalOpen = false;
  dynamicForm: null | formUtils.DynamicFormController;

  setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  async openEditPrimaryModal(subscriberId: string, editEeFormId: string): Promise<void> {
    this.isEditPrimaryModalOpen = true;
    this.setLoading(true);
    this.dynamicForm = null;
    this.form = INITIAL_FORM_OBJECT;
    await this.rootStore.subscriberStore.setCurrentSubscriber(subscriberId);

    const form = await requestFormById(editEeFormId);
    runInAction(() => {
      this.form = form;
      this.createFormController({ ...this.rootStore.subscriberStore.currentSubscriber.common });
      this.setLoading(false);
    });
  }

  closeEditPrimaryModal(): void {
    this.isEditPrimaryModalOpen = false;
  }

  async saveSubscribersChanges(periodId: string, updateStatistics: () => Promise<void>): Promise<void> {
    this.setLoading(true);
    if (!this.dynamicForm) return;
    await this.rootStore.subscriberStore.updatePrimary(
      periodId,
      this.dynamicForm.getCanonicalAnswers() as Record<string, string>,
    );
    await runInAction(async () => {
      await updateStatistics();
      this.setLoading(false);
      this.closeEditPrimaryModal();
    });
  }

  createFormController(answers: Record<string, string>): void {
    this.setLoading(true);
    this.dynamicForm = new formUtils.DynamicFormController(this.form, this.rootStore.userStore.userRoles);
    this.dynamicForm.populateFields(answers);
    this.setLoading(false);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.dynamicForm = null;
    this.form = INITIAL_FORM_OBJECT;

    makeObservable(this, {
      loading: observable,
      isEditPrimaryModalOpen: observable,
      setLoading: action.bound,
      openEditPrimaryModal: action.bound,
      closeEditPrimaryModal: action.bound,
      saveSubscribersChanges: action.bound,
      createFormController: action.bound,
    });
  }
}
